/**
 * This is intended to be a temporary fix for the issue of filtering stock by options.
 * Essentially, we want to check stock only if the user is filtering by options[x].
 */
export const isFilteringByOptions = (facetFilters: string[][]) =>
  Boolean(
    facetFilters.find((facet) =>
      facet.some((f) => f.includes('options') || f.includes('variant_title')),
    ),
  )
